/* eslint-disable id-length */
import { MOBILE_V1 } from './utils/endpoints';
export default _ref => {
  var shared = _ref.shared,
    _ref$endpoints = _ref.endpoints,
    endpoints = _ref$endpoints === void 0 ? {} : _ref$endpoints;
  var apiClient = shared.apiClient,
    getAbsoluteUrl = shared.getAbsoluteUrl;
  var postWithToken = apiClient.postWithToken;
  var _endpoints$propertyAl = endpoints.propertyAlertsEndpoint,
    propertyAlertsEndpoint = _endpoints$propertyAl === void 0 ? "".concat(MOBILE_V1, "/alerts") : _endpoints$propertyAl;
  var endpoint = action => "".concat(getAbsoluteUrl(propertyAlertsEndpoint), "/").concat(action);
  var CHECK = endpoint('check');
  var GET = endpoint('get');
  var PUT = endpoint('put');
  var REMOVE = endpoint('remove');
  var FETCH = endpoint('fetch');
  var EARLY_ACCESS = endpoint('earlyAccess');
  var updatePropertyAlert = _ref2 => {
    var id = _ref2.id,
      name = _ref2.name,
      frequency = _ref2.frequency,
      listingType = _ref2.listingType,
      query = _ref2.query;
    return postWithToken(PUT, {
      alert: {
        id,
        name,
        frequency,
        listingType,
        query
      }
    }).then(_ref3 => {
      var alert = _ref3.alert;
      return alert;
    });
  };
  var createPropertyAlert = _ref4 => {
    var name = _ref4.name,
      frequency = _ref4.frequency,
      listingType = _ref4.listingType,
      query = _ref4.query;
    return updatePropertyAlert({
      name,
      frequency,
      listingType,
      query
    });
  };
  var removePropertyAlert = id => postWithToken(REMOVE, {
    id
  });
  var getPropertyAlert = id => postWithToken(GET, {
    id
  }).then(_ref5 => {
    var alert = _ref5.alert;
    return alert;
  });
  var checkPropertyAlert = (query, listingType) => postWithToken(CHECK, {
    query,
    listingType
  });
  var fetchPropertyAlerts = () => postWithToken(FETCH);
  var setEarlyAccessEnabled = earlyAccessEnabled => postWithToken(EARLY_ACCESS, {
    earlyAccessEnabled
  }).then(result => result.earlyAccessEnabled);
  var alertsApi = {
    createPropertyAlert,
    updatePropertyAlert,
    removePropertyAlert,
    getPropertyAlert,
    checkPropertyAlert,
    fetchPropertyAlerts,
    setEarlyAccessEnabled
  };
  return alertsApi;
};